var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_196863534760440285386097621372345612579",
    d: "M13.943 3.59c5.601.971 9.862 5.874 9.862 11.776 0 6.6-5.329 11.951-11.903 11.951C5.33 27.317 0 21.967 0 15.366 0 9.464 4.26 4.56 9.862 3.59v2.707c-4.13.933-7.217 4.639-7.217 9.069 0 5.134 4.145 9.295 9.257 9.295 5.113 0 9.258-4.161 9.258-9.295 0-4.43-3.086-8.136-7.218-9.07zM11.903 0c.75 0 1.36.609 1.36 1.36v9.23c0 .752-.61 1.361-1.36 1.361-.752 0-1.36-.609-1.36-1.36V1.36c0-.752.608-1.361 1.36-1.361z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_214272282437957772218048506060218861884",
    d: "M-4.754 -3.152H28.168V30.469H-4.754z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_94504548642927664077048400318398321509",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164 -167) translate(148 159) translate(16 8) translate(4.293 2.341)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_25355652147346144318520186261122770114",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_196863534760440285386097621372345612579"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_25355652147346144318520186261122770114)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_214272282437957772218048506060218861884"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_94504548642927664077048400318398321509)",
    xlinkHref: "#hinava_random_uuid_214272282437957772218048506060218861884"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnOff);
export default __webpack_public_path__ + "static/media/on-off.5aa2c5e650ac39f6bc3bf80a9c817fa3.svg";
export { ForwardRef as ReactComponent };